import { useGetSuppliersQuery } from "@/services/supplier";
import { Load } from "components/load";
import PageError from "components/page-error";
import React from "react";
import { columns } from "../components/columns";
import { DataTable } from "../components/data-table";
import { useFilterState } from "../ducks/hooks/state";
import { ContentContainer, PageLayout, PageTitle } from "components/layout";



export const SupplierTax: React.FC = () => {
  const filterState = useFilterState();

  const baseFilters = {
    meta: {
      page: filterState.filters.meta?.page || 1,
      perPage: filterState.filters.meta?.perPage || 10,
    },
  };

  const dynamicFilters = Object.entries(filterState.filters).reduce(
    (acc, [key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        acc[key] = value;
      }
      return acc;
    },
    {} as Record<string, unknown>
  );

  const filters = { ...baseFilters, ...dynamicFilters };

  const { data: supplier, isLoading, isFetching, error } = useGetSuppliersQuery(filters);

  const { data, meta } = supplier || {
    data: [],
    meta: { page: 1, perPage: 10, total: 0, totalPages: 0 },
  };

  if (isLoading) return <Load />;
  if (error) return <PageError status={500} message="Erro ao buscar dados" />;
  return (
    <PageLayout>
      <PageTitle title="Fornecedores" description="Gerencie os fornecedores cadastrados" />
      <ContentContainer>
        <DataTable data={data as any} columns={columns} meta={meta} isLoading={isFetching} />
      </ContentContainer>
    </PageLayout>
  );
};
